'use client'

import { useCallback } from 'react'
import createApp from '@shopify/app-bridge'
import { Redirect } from '@shopify/app-bridge/actions'
import { useBoot } from '@/app/(app)/context/BootContext'

const APP_HANDLE = (process.env.NEXT_PUBLIC_SHOPIFY_APP_HANDLE || 'sigma-sense-1').trim()
const API_KEY = (process.env.NEXT_PUBLIC_SHOPIFY_API_KEY || '').trim()

export function useBillingRedirects() {
  const { bootHost: host } = useBoot()

  const redirectToManagePlan = useCallback(
    (storeId: string) => {
      const url = `https://admin.shopify.com/store/${storeId}/charges/${APP_HANDLE}/pricing_plans`
      if (host && API_KEY) {
        const app = createApp({ apiKey: API_KEY, host, forceRedirect: true })
        Redirect.create(app).dispatch(Redirect.Action.REMOTE, url)
      } else {
        window.location.href = url
      }
    },
    [host]
  )

  const redirectToBillingSettings = useCallback(
    (storeId: string) => {
      const url = `https://admin.shopify.com/store/${storeId}/charges/${APP_HANDLE}/pricing_plans`
      if (host && API_KEY) {
        const app = createApp({ apiKey: API_KEY, host, forceRedirect: true })
        Redirect.create(app).dispatch(Redirect.Action.REMOTE, url)
      } else {
        window.location.href = url
      }
    },
    [host]
  )

  return {
    redirectToManagePlan,
    redirectToBillingSettings,
  }
}
